import { useForm } from 'react-hook-form'
import { EnvelopeIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'
import { Link } from 'libs/router'
import { AuthCard, Button } from 'shared/components'
import { InputGroup } from 'shared/molecules'
import { useResetPasswordMutation } from './mutations/useResetPasswordMutation'

export interface ResetPasswordReqBody {
	email: string
}

const PasswordResetPage = () => {
	const { t } = useTranslation()
	const { resetPasswordMutation, isResetPasswordLoading, isResetPasswordSuccess } =
		useResetPasswordMutation()

	const {
		register,
		handleSubmit,
		formState: { errors }
	} = useForm({
		mode: 'onChange'
	})

	const onSubmit = (data: ResetPasswordReqBody) => {
		resetPasswordMutation(data)
	}

	return (
		<AuthCard
			title={t('Forgot password')}
			description={t('Enter your email and we will send you a link to reset your password.')}
			footer={
				<Link className="font-medium text-primary hover:underline" to="/">
					{t('Continue to your account')}
				</Link>
			}>
			{isResetPasswordSuccess ? (
				<div className="flex items-start gap-3 rounded-md border border-success/40 bg-success-soft p-4 text-success">
					<EnvelopeIcon className="mt-0.5 h-5 w-5 shrink-0 stroke-2" />
					<div>
						<p className="text-sm font-semibold">{t('Email sent')}</p>
						<p className="mt-0.5 text-[13px]">
							{t('Check your inbox for a link to reset your password.')}
						</p>
					</div>
				</div>
			) : (
				<form className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
					<InputGroup
						id="email"
						type="email"
						label={t('Email')}
						placeholder="name@example.com"
						autoComplete="email"
						{...register('email')}
						error={(errors as any).email}
					/>
					<Button
						type="submit"
						isLoading={isResetPasswordLoading}
						className="h-10 w-full rounded-md px-4 text-sm font-medium shadow">
						{t('Request password reset')}
					</Button>
				</form>
			)}
		</AuthCard>
	)
}

export default PasswordResetPage
